export default "__VITE_ASSET__be235667__"